import { Switch, Route } from "react-router-dom";
import ModuloADS from "../../Pages/ModuloAds";
import AtendimentoRepasse from "../../Pages/Repasse/AtendimentoRepasse";
import EtapasGrupo from "../../Pages/Repasse/EtapasGrupo";
import { GestaoAtendimentoRepasse } from "../../Pages/Repasse/GestaoAtendimentos";
import GestaoRepasse from "../../Pages/Repasse/GestaoRepasse";
import RelatoriosBIRepasse from "../../Pages/Repasse/RelatorioBI";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import PesquisaSatisfacaoRepase from "../../Pages/Repasse/PesquisaSatisfacaoRepasse/PesquisaSatisfacaoRepasse";

export default function RotasRepasse() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.DASHBOARD.DS_PATH}
                component={() => <></>}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH}
                component={GestaoAtendimentoRepasse.TodosAtendimentos}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.TODOS.ID_TELA}
            />

            <PrivatedRoute
                path={
                    ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                        .DS_PATH
                }
                component={GestaoAtendimentoRepasse.MeusAtendimentos}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={
                    ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
                        .USUARIO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH}
                component={GestaoAtendimentoRepasse.GrupoAtendimentos}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.GESTAO_ATENDIMENTOS.GRUPO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.GESTAO_REPASSE.DS_PATH}
                component={GestaoRepasse}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.GESTAO_REPASSE.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoRepasse}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.ATENDIMENTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.CAPYS_BI.DS_PATH}
                component={RelatoriosBIRepasse}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.CAPYS_BI.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.ETAPAS_GRUPO.DS_PATH}
                component={EtapasGrupo}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.ETAPAS_GRUPO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.REPASSE.TELAS.PESQUISA_SATISFACAO.DS_PATH}
                component={PesquisaSatisfacaoRepase}
                isPrivate
                idModulo={ACESSOS.REPASSE.ID_MODULO}
                idTela={ACESSOS.REPASSE.TELAS.PESQUISA_SATISFACAO.ID_TELA}
            />

            <Route path="/Repasse/:idModulo/" exact component={ModuloADS} />
        </Switch>
    );
}
